enum ORDER_STATUS {
  PENDING = 0,
  COMPLETED = 1,
  PENDING_CANCELLATION = 2,
  CANCELLED = 3,
  ERROR = 4,
}

export default ORDER_STATUS;
